import { defineStore, storeToRefs } from 'pinia';
import { computed, ref } from 'vue';
import { useTokenStore } from './token';

export type JobCounts = {
  [key: string]: {
    pending: number;
    reserved: number;
    delayed: number;
  };
};
export const useCountStore = defineStore('counts', () => {
  const { csToken } = storeToRefs(useTokenStore());

  const jobCounts = ref({} as JobCounts);
  const isLoading = ref(false);

  const sortedCounts = computed(() => {
    const counts = jobCounts.value || {};
    return Object.keys(counts)
      .sort()
      .reduce((acc, key) => {
        acc[key] = counts[key];
        return acc;
      }, {});
  });

  async function loadJobCounts() {
    if (csToken.value === '' || isLoading.value) {
      return;
    }
    isLoading.value = true;
    const response = await fetch(`${import.meta.env.VITE_API_BASE_URL}/counts`, {
      headers: {
        Authorization: `Bearer ${csToken.value}`,
      },
    });
    isLoading.value = false;
    if (response.ok) {
      jobCounts.value = await response.json();
      return;
    }
    alert(`Failed to load job counts ${response.status}: ${JSON.stringify(await response.json())}`);
  }

  return { jobCounts, sortedCounts, isLoading, loadJobCounts };
});
